import React from 'react'
import * as Icon from 'react-feather';
function TableRow(props) {
    
    return (
        <div className="flex border-b border-dashed border-vp-lightbrown last:border-0 ml-8 min-w-max ">
                <div className="table-left-content">{props.content.title}</div>
                  
                    {props.content.values && props.content.values.map((e,i)=>{
                        return <div key={i} className={`${typeof e === "string" && !props.notbold ? "font-bold" : ""} ${typeof e === "string" ? "p-2.5" : "p-1"} justify-center  w-full min-w-10 align-top  bg-primary-light ${i%2===0? 'bg-opacity-20' : 'bg-opacity-10'} ml-2 flex items-center`}>
                            {typeof e === "string" ? e : e ? <Icon.Check className="text-primary w-6 mx-auto" />: ""}
                        </div>
                    })}  
                    
                </div>
    )
}


export default TableRow

